module.exports = __webpack_public_path__ + "img/bb_g3_t_mouth-05.8f281687.svg";